let dropdownContain = document.querySelectorAll('.variant-title-dropdown')

for (var i = 0; i < dropdownContain.length; i++) {
    dropdownContain[i].addEventListener('click', function(event) {
        this.classList.toggle("showing");
    });
}

document.addEventListener("product:variant-change", function (evt) {
    let newVariant = evt.detail.variant.title;
    let productTextField = document.querySelector(`[data-option-value="${newVariant}"]`).closest('.variant-drop-down-inner').previousElementSibling.querySelector('.variant-title-text');
    if(productTextField) {
      let selectedVariant = evt.detail.variant.title;
      productTextField.innerHTML = selectedVariant;
    }
});
  

